import axios from 'axios'

export const getEventByPk = async(id) => {
    let data;
    await axios.get(`${process.env.REACT_APP_API_HOST}/events/${id}`).then(resp => {
        data = resp.data;
    });
    return data;
}